import React, { useContext } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { RevenueCalendarContext } from '../context/RevenueCalendarProvider';
import { RevenueContext } from '../context/RevenueProvider';
import RevenueHeader from '../components/RevenueHeader/RevenueHeader';
import RevenueDetails from '../components/RevenueDetails/RevenueDetails';
import ProcessingSpinner from '../../components/UI/Spinner/ProcessingSpinner';
import UploadFileModel from '../../components/UI/UploadFile/UploadFileModal';
import UnblockContract from '../../components/UI/Modal/UnblockContract';
import { RequestStatus } from '../../common/const/RequestStatus';
import './index.css';
import WeeklyRevenue from '../components/WeeklyRevenue/WeeklyRevenue';

function ConcessionRevenue(props) {

    const { revenueDate, isLoading, isError, dataLoading, isSuccessfulSubmitted, errorMessage,
        setShowInstructions, resetSubmittedAndErrorFlags, setErrorPopUpHandler, weeklyStartDate, weeklyEndDate } = useContext(RevenueCalendarContext);

    const { revenue, modelHeaderTitle, showUploadFileModel, acceptFileType, selectedRevenue, showUnblockRequestModel,
        selectedContractCodeIndex, remarksOptions, handlerOnUploadExcelClick, handlerOnImportFromExcelClick,
        handlerOnExportToExcelClick, setRevenueDataHandler, submitRevenueHandler, cancelChangeRequestHandler,
        submitSelectedRevenueHandler, resetUploadFileFlags, handlerOnUnblockRequestIconClick,
        resetUnblockRequestFlag, onSubmitUnblockRequestHandler } = useContext(RevenueContext);

    const resetUploadFileFlagsHandler = () => {
        resetUploadFileFlags(false, "", "");
    }

    return (
        <Container className="Revenue-container">
            <Row className={(revenueDate || (weeklyStartDate && weeklyEndDate)) ? "Revenue-header-row" : "Revenue-header-row Revenue-header-row-transparent"}>
                {
                    (revenueDate || (weeklyStartDate && weeklyEndDate)) && <RevenueHeader
                        BusinessPartnerCode={props.BusinessPartnerCode}
                        showInstructionshandler={setShowInstructions}
                        handlerOnImportFromExcelClick={handlerOnImportFromExcelClick}
                        handlerOnExportToExcelClick={handlerOnExportToExcelClick}
                        isExportToExcelEnable={revenue && revenue.length > 0}
                        isRevenueAvailableToImport={revenue && revenue.length > 0 &&
                            revenue.some(d => d.isSubmitted === false
                                && d.isMonthlySubmitted === true)} />
                }
            </Row>
            <Row className="Revenue-details-row">
                {(revenueDate || (weeklyStartDate && weeklyEndDate)) && remarksOptions && !isLoading &&
                    <div className="Revenue-Main">
                        {!props.isWeekly ?
                            < RevenueDetails
                                revenueDate={revenueDate}
                                revenue={revenue}
                                setRevenueData={setRevenueDataHandler}
                                submitRevenue={submitRevenueHandler}
                                isSuccessfulSubmitted={isSuccessfulSubmitted}
                                isError={isError}
                                errorMessage={errorMessage}
                                resetSubmittedAndErrorFlags={resetSubmittedAndErrorFlags}
                                remarksOptions={remarksOptions}
                                setErrorPopUpHandler={setErrorPopUpHandler}
                                cancelChangeRequestHandler={cancelChangeRequestHandler}
                                submitSelectedRevenueHandler={submitSelectedRevenueHandler}
                                dataLoading={dataLoading}
                                handlerOnUnblockRequestIconClick={handlerOnUnblockRequestIconClick}
                            /> :
                            < WeeklyRevenue
                                revenue={revenue}
                                setRevenueData={setRevenueDataHandler}
                                submitRevenue={submitRevenueHandler}
                                isSuccessfulSubmitted={isSuccessfulSubmitted}
                                isError={isError}
                                errorMessage={errorMessage}
                                resetSubmittedAndErrorFlags={resetSubmittedAndErrorFlags}
                                remarksOptions={remarksOptions}
                                setErrorPopUpHandler={setErrorPopUpHandler}
                                cancelChangeRequestHandler={cancelChangeRequestHandler}
                                submitSelectedRevenueHandler={submitSelectedRevenueHandler}
                                dataLoading={dataLoading}
                                handlerOnUnblockRequestIconClick={handlerOnUnblockRequestIconClick}
                            />
                        }
                        {revenue && revenue.length > 0 && showUploadFileModel &&
                            <UploadFileModel showModel={showUploadFileModel}
                                acceptFileType={acceptFileType}
                                showHeader={showUploadFileModel}
                                onHideHandler={resetUploadFileFlagsHandler}
                                headerTitle={modelHeaderTitle}
                                handlerOnUploadClick={handlerOnUploadExcelClick}
                                allowedFileType={"fileformatxlsx"}
                                selectedRowIndex={selectedContractCodeIndex}
                                selectedRevenue={selectedRevenue}
                                handlerOnDeleteFileClick={undefined}
                                isModifying={false}
                                weeklyStartDate = {weeklyStartDate}
                                weeklyEndDate = {weeklyEndDate}
                            />
                        }
                        {revenue && revenue.length > 0 && showUnblockRequestModel &&
                            <UnblockContract showModel={showUnblockRequestModel}
                                onHideHandler={resetUnblockRequestFlag}
                                onSubmitUnblockRequestHandler={onSubmitUnblockRequestHandler}
                                setRevenueData={setRevenueDataHandler}
                                rowIndex={selectedContractCodeIndex}
                                row={selectedRevenue}
                                BusinessPartnerCode={props.BusinessPartnerCode}
                                RevenueDate={revenueDate}
                            />
                        }
                    </div>
                }
                {
                    isLoading ? <ProcessingSpinner Status={RequestStatus.Inprogress.id}
                        BusinessPartnerCode={props.BusinessPartnerCode}
                        RevenueDate={revenueDate}
                    />
                        : undefined
                }
            </Row>
        </Container>
    );
}

export default ConcessionRevenue;